import { Life } from './Life';
import { Logo } from './Logo';
import { Score } from './Score';

export function GameHeader() {
  return (
    <div className="fixed w-full top-8 px-10">
      <div className="container flex flex-row justify-between items-center mx-auto">
        <div className="flex items-center w-48">
          <Logo className="w-full" />
        </div>
        <Score />
        <Life />
      </div>
    </div>
  );
}
